import { Filter } from '../components/SearchMenu/SearchMenuFilterBox'
import { Translations } from './localization'

export enum SearchResultsCheckboxGroupType {
  DocumentType = 'type',
}

export enum SearchResultsCheckboxFilterType {
  PressReleases = 'pressReleases',
  RegulatoryNews = 'regulatoryNews',
  Reports = 'reports',
  Updates = 'updates',
}

export enum SearchResultsDropdownFilterType {
  BusinessLine = 'businessLine',
  Company = 'company',
  Country = 'country',
  Fund = 'fund',
  Office = 'office',
  Sdg = 'sdg',
  Sector = 'sector',
  Team = 'team',
  Theme = 'theme',
  WorkTitle = 'workTitle',
  Year = 'year',
  Location = 'location',
  Status = 'status',
}

export enum SearchResultsQueryFilterType {
  Query = 'q',
}

export type SearchResultsFilterType =
  | SearchResultsCheckboxGroupType
  | SearchResultsCheckboxFilterType
  | SearchResultsDropdownFilterType
  | SearchResultsQueryFilterType

// There's no good way to merge two enums, but using both a type and an object works decently.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchResultsFilterType = {
  ...SearchResultsCheckboxGroupType,
  ...SearchResultsCheckboxFilterType,
  ...SearchResultsDropdownFilterType,
  ...SearchResultsQueryFilterType,
}

const typeTranslationNames = {
  [SearchResultsFilterType.BusinessLine]: 'businessLine',
  [SearchResultsFilterType.Company]: 'company',
  [SearchResultsFilterType.Country]: 'country',
  [SearchResultsFilterType.Location]: 'location',
  [SearchResultsFilterType.Fund]: 'fund',
  [SearchResultsFilterType.Office]: 'office',
  [SearchResultsFilterType.PressReleases]: 'pressReleasesFilter',
  [SearchResultsFilterType.RegulatoryNews]: 'regulatoryNewsFilter',
  [SearchResultsFilterType.Reports]: 'reports',
  [SearchResultsFilterType.Sdg]: 'sdg',
  [SearchResultsFilterType.Sector]: 'sector',
  [SearchResultsFilterType.Theme]: 'theme',
  [SearchResultsFilterType.Updates]: 'updatesFilter',
  [SearchResultsFilterType.WorkTitle]: 'workTitle',
  [SearchResultsFilterType.Year]: 'year',
}

export const getSearchResultsFilterDisplayName = (
  type: SearchResultsFilterType,
  translations: Translations
): string => {
  if (type in typeTranslationNames) {
    const localizationKey = typeTranslationNames[type]

    if (localizationKey in translations) {
      return translations[localizationKey] ?? type
    }
  }

  return type
}

export const getSearchResultsCheckboxFilters = (translations: Translations): Filter[] => [
  {
    isActive: false,
    name: getSearchResultsFilterDisplayName(
      SearchResultsFilterType.PressReleases,
      translations
    ),
    value: SearchResultsFilterType.PressReleases,
  },
  {
    isActive: false,
    name: getSearchResultsFilterDisplayName(
      SearchResultsFilterType.RegulatoryNews,
      translations
    ),
    value: SearchResultsFilterType.RegulatoryNews,
  },
  {
    isActive: false,
    name: getSearchResultsFilterDisplayName(
      SearchResultsFilterType.Updates,
      translations
    ),
    value: SearchResultsFilterType.Updates,
  },
]
